import { CommaSeparator } from '@/components/custom';
import { TriangleAlert } from 'lucide-react';
import { TProps } from '.';

const BannerUserInfosWarning = ({ countWarningReceived }: Pick<TProps, 'countWarningReceived'>) => {

	if (!countWarningReceived || countWarningReceived <= 0) {
		return <></>;
	}

	return (
		<>
			<CommaSeparator />
			<div
				className='flex items-center space-x-1 text-yellow-500 text-sm font-semibold'
				title={`${countWarningReceived} avertissement(s) reçu(s)`}>
				<span>
					{countWarningReceived}
				</span>
				<TriangleAlert
					size={16} />
			</div>
		</>
	);

};

export default BannerUserInfosWarning;
